const { getUser } = require('@/services/localstorage');

const tokenAuth = async (router, next) => {
  const user = getUser();

  if (!user) {
    // eslint-disable-next-line no-console
    console.log('unauthorized access');
    return router.push('/login');
  }

  return next();
};

export {
  tokenAuth
};


// WEBPACK FOOTER //
// ./src/middleware/auth.js